import { Box } from '@mui/material';
import { ReactNode } from 'react';
import SectionTypography from './SectionTypography';

/**
 * The properties for a section
 */
interface SectionProps {
  /**
   * The title of the section
   */
  title: string;
  /**
   * Additional content to add to the right side of the title
   */
  rightSection?: ReactNode;
  /**
   * The children of the section
   */
  children: ReactNode;
}

/**
 * A section within the training view
 */
const Section = ({ title, rightSection, children }: SectionProps) => {
  return (
    <Box marginBottom="3em">
      <Box display="flex" justifyContent="space-between" marginBottom="2em">
        <SectionTypography title={title} />
        {rightSection}
      </Box>
      {children}
    </Box>
  );
};

export default Section;
